import {Fragment, useEffect, useRef, useState} from 'react';

import {Button} from 'primereact/button';
import {OverlayPanel} from 'primereact/overlaypanel';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Checkbox} from 'primereact/checkbox';
import {InputNumber} from 'primereact/inputnumber';
import {Dropdown} from 'primereact/dropdown';
import {InputText} from 'primereact/inputtext';

import {FormatDisplay} from '../format';
import {getLocale, useTranslation} from '../language';

export const ConfigColumns = props => {
  const {t} = useTranslation();
  const locale = getLocale();

  const op = useRef(null);

  const [columns, setColumns] = useState([]);
  const [sumColumns, setSumColumns] = useState([]);

  useEffect(() => {
    // Tên cột do API cấu hình trả về theo ngôn ngữ nên phải tải lại khi locale thay đổi.
    load();
  }, [locale]); // eslint-disable-line react-hooks/exhaustive-deps

  const load = () => {
    props.get().then(data => {
      setColumns(data);

      const _columns = [], sumColumns = [];
      data?.forEach(columnOrigin => {
        if (['int32', 'numeric'].includes(columnOrigin.dataType)) {
          sumColumns.push({value: columnOrigin.fieldName, label: columnOrigin.lable});
        }
        if (columnOrigin.active) {
          let defaultHard: any = {};
          switch (columnOrigin.dataType) {
            case 'int32':
            case 'numeric':
              defaultHard = {
                dataType: 'custom', customCell(rowData: any): any {
                  return FormatDisplay.number(rowData[columnOrigin.fieldName], FormatDisplay.getFractionDigits(rowData, columnOrigin.fieldName));
                }, style: {justifyContent: 'end'}
              }
              break;
            case 'date':
            case 'dateTime':
              defaultHard = {dataType: 'date'};

              if (columnOrigin.matchMode) {
                defaultHard.filterType = 'range-date';
                if (columnOrigin.fieldName === 'invoiceDate') {
                  defaultHard.filterField = 'fromDate@toDate';
                } else {
                  defaultHard.filterField = columnOrigin.filterField;
                }
                defaultHard.matchMode = columnOrigin.matchMode;
              }
              break;
          }
          const hard = props.hardColumns[columnOrigin.fieldName] ? props.hardColumns[columnOrigin.fieldName] : defaultHard;
          _columns.push({
            field: columnOrigin.fieldName,
            header: columnOrigin.lable,
            width: columnOrigin.width || 120,
            sum: columnOrigin.sum,
            ...hard,
            matchMode: columnOrigin.matchMode
          });
        }
      });

      setSumColumns(sumColumns);

      props.setColumns(_columns);
      props.setColumnsState(Date.now);
    });
  }

  const onRowReorder = e => {
    setColumns(e.value);
  }

  const onColumnChange = (rowIndex, field, value) => {
    setColumns(prevState => {
      prevState[rowIndex][field] = value;
      return [...prevState];
    });
  }

  const restore = () => {
    props.restore().then(() => {
      load();
      op.current.hide();
    });
  }

  const save = () => {
    props.set(columns).then(() => {
      load();
      op.current.hide();
    });
  }

  return (
    <Fragment>
      <Button icon="pi pi-cog" aria-label={t('common.settings')} title={t('common.settings')} className="p-button-rounded p-button-outlined p-button-secondary" onClick={e => op.current.toggle(e)}/>
      <OverlayPanel ref={op} style={{width: '600px'}}>
        <DataTable value={columns} reorderableRows onRowReorder={onRowReorder}
                   scrollable scrollHeight="50vh" responsiveLayout="scroll" className="p-fluid" size={'small'}>
          <Column body={(rowData, {rowIndex}) =>
            <Checkbox checked={rowData.active} onChange={e => onColumnChange(rowIndex, 'active', e.checked)}/>}
                  style={{minWidth: '2em', maxWidth: '2em'}}/>
          <Column field="lable" header={t('common.columnName')} body={(rowData, {rowIndex}) =>
            <InputText value={rowData.lable} onChange={e => onColumnChange(rowIndex, 'lable', e.target.value)}/>}
          />
          <Column field="width" header={t('common.columnWidth')} body={(rowData, {rowIndex}) =>
            <InputNumber locale={FormatDisplay.locales} value={rowData.width} min={10} max={500} onValueChange={e => onColumnChange(rowIndex, 'width', e.value)}/>}
                  style={{minWidth: '8em', maxWidth: '8em'}}/>
          <Column field="sum" header={t('common.total')} body={(rowData, {rowIndex}) =>
            <Dropdown value={rowData.sum} options={sumColumns} onChange={e => onColumnChange(rowIndex, 'sum', e.value)} showClear style={{width: '100%'}}/>}
                  style={{minWidth: '17em', maxWidth: '17em'}}/>
          <Column rowReorder style={{minWidth: '4em', maxWidth: '4em'}}/>
        </DataTable>
        <div className="text-right mt-4">
          <Button label={t('common.restoreDefault')} className="p-button-text p-button-sm mr-2" onClick={restore}/>
          <Button label={t('common.save')} icon="pi pi-check" className="p-button-sm" onClick={save}/>
        </div>
      </OverlayPanel>
    </Fragment>
  );
}
